export function formatPrice(price: number | string, showCurrency: boolean = true): string {
    let numericPrice = typeof price === 'string' ? parseFloat(price) : price;
    if (isNaN(numericPrice)) {
        numericPrice = 0;
    }

    // Se siamo nel server, usa formattazione manuale
    if (typeof window === 'undefined') {
        const roundedPrice = Math.round(numericPrice);
        const parts = roundedPrice.toString().split('.');
        const integerPart = parts[0];
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        return showCurrency ? `${formattedInteger}\u00A0€` : formattedInteger;
    }

    // Se siamo nel client, usa Intl.NumberFormat
    const numberFormat = new Intl.NumberFormat('de-DE', {
        style: showCurrency ? 'currency' : 'decimal',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
    });

    let formattedPrice = numberFormat.format(numericPrice);

    if (!showCurrency) {
        formattedPrice = formattedPrice.replace(/[€\s]/g, '').trim();
    }

    return formattedPrice;
}

/**
 * Converte un valore prezzo (string con virgola italiana, number, o null) in number.
 * Es: "1.234,56" → 1234.56 | 1234 → 1234 | null → 0
 */
export const parsePrice = (price: any): number => {
    if (!price) return 0;
    if (typeof price === 'number') return price;
    const str = String(price);
    if (str.includes(',')) {
        return parseFloat(str.replace(/\./g, '').replace(',', '.'));
    }
    return parseFloat(str);
};
